module.exports = "#usersBoard{\n    background-color:white;\n    margin:auto;\n    height:auto;\n    width:1200px;\n}\n\nlegend{\n    text-align:center;\n}"